export default __webpack_public_path__ + "static/img-1-0f43fabca6062ba1bf9456bb7589cbb9.jpg";